import { get } from 'lodash';
import { createPropsSelectorOrm } from '../utils';

export const getDepotData = createPropsSelectorOrm((session, depotlCode) =>
  get(session.Depot.withId(depotlCode), 'ref')
);
